import gql from "graphql-tag";

const ABOUT_PAGE_QUERY = gql`
    query{
        aboutPage{
        introduction
        content
        mission
        vision
        Story_Introduction
        Story_Content
        Conservation_Section{
            title
            introduction
            content
            carousel{
              url
              formats
            }
          }
          Roots_Section{
            title
            introduction
            content
            carousel{
              url
              formats
            }
          }
          Identity_Section{
            title
            introduction
            content
            carousel{
              url
              formats
            }
          }
          teams{
            name
            job
            bio 
            linkedin
            facebook
            instagram
            github
            pinterest
            twitter
            image{
                url
                formats
              }
            }
        }
    }
`;

export default ABOUT_PAGE_QUERY